import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

import { MatrizEventosComponent } from './matriz-eventos/matriz-eventos.component';
import { AnalisisEventosComponent } from './analisis-eventos/analisis-eventos.component';
import { AnalaisisCombinadoComponent } from './analaisis-combinado/analaisis-combinado.component';
import { MapaCalorComponent } from './mapa-calor/mapa-calor.component';

const routes: Routes = [{
  path: 'app/operative-potencial',
  component: ContenedorComponent,
  children: [
    {path: 'matriz-eventos-pot', component: MatrizEventosComponent, canActivate: [authGuardSubmodule]},
    {path: 'analisis-eventos-pot', component: AnalisisEventosComponent, canActivate: [authGuardSubmodule]},
    {path: 'analisis-combinado-pot', component: AnalaisisCombinadoComponent, canActivate: [authGuardSubmodule]},
    {path: 'mapa-calor-pot', component: MapaCalorComponent, canActivate: [authGuardSubmodule]},
  ]

}];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperativoPotencialRoutingModule { }
